// ✅ React Hook for Automatic Page View Tracking
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook to automatically track page views
 * This will track page views whenever the route changes
 */
export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page information
    const pageName = location.pathname;
    const pageTitle = document.title || 'GutenStack';
    const pageLocation = window.location.href;

    // Track the page view
    trackPageView(pageName, pageTitle, pageLocation);
  }, [location]);
};

export default useAnalytics;
